
export default [
  {
    path: '/turlar',
    name: 'Turlar',
    meta: {
      auth: true,
      title: 'Turlar',
    },
    component: () => import('../../views/turlar/list.vue')
  },
  {
    path: '/tur',
    name: 'Tur Yeni',
    meta: {
      auth: true,
      title: 'Tur Bilgisi',
    },
    component: () => import('../../views/turlar/card.vue')
  },
{
    path: '/tur/:id',
    name: 'Tur',
    meta: {
      auth: true,
      title: 'Tur Bilgisi',
    },
    component: () => import('../../views/turlar/card.vue')
  },
  {
    path: '/terminal',
    name: 'Terminal',
    meta: {
      auth: true,
      title: 'Terminal',
    },
    component: () => import('../../views/terminal/list.vue')
  },

]
